import React from "react";
import { IconButton, ThemeProvider, createTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export interface CloseIconButtonProps {
  variant?: "circle" | "square";
  onClose: () => void;
}

const CloseIconButton = ({ variant = "circle", onClose }: CloseIconButtonProps) => {

  const theme = createTheme({});

  return (
    <ThemeProvider theme={theme}>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 14,
          top: 14,
          color: "#333333",
        }}
      >
        <CloseIcon />
      </IconButton>
    </ThemeProvider>
  );
};

export default CloseIconButton;